import React, { useContext } from "react";
import styled from "styled-components";
import { AuthContext } from "../context/AuthProvider";
import PageHeader from "../components/PageHeader";
import OnboardingTab from "./dashboard/OnboardingTab";
import { FileTextOutlined } from "@ant-design/icons";
import { LAYOUT_CONSTANTS } from "../lib/breakpoints";

/**
 * Lease-Ups page: track applicants from application → fee → screening → lease signature.
 * Layout matches Dashboard, Listings, and other app pages (nav bar + constrained content area).
 *
 * Demo UI (no live draft tenants required): open `/lease-ups?debug=true` (same as Dashboard/Units).
 */
const LeaseUpsPage = () => {
  const { user } = useContext(AuthContext);

  return (
    <PageContainer>
      <PageHeader
        className="lease-ups-page-header"
        title="Lease-Ups"
        subtitle="Track applicants from application to lease signature"
        icon={FileTextOutlined}
      />
      <OnboardingTab userId={user?.uid} />
    </PageContainer>
  );
};

const PageContainer = styled.div`
  box-sizing: border-box;
  padding: 2rem;
  background: var(--color-bg-primary);
  min-height: 100vh;
  position: relative;
  width: ${LAYOUT_CONSTANTS.DESKTOP_CONTENT_WIDTH};
  max-width: 100%;
  margin: 0 auto;

  @media (max-width: 768px) {
    padding: 0.75rem 0.75rem 1.25rem;
    width: 100%;
    min-width: ${LAYOUT_CONSTANTS.MIN_CONTENT_WIDTH};
    overflow-x: clip;
  }

  @media (min-width: 768px) and (max-width: 1200px) {
    padding: 1.5rem;
    width: min(100%, 90vw);
  }
`;

export default LeaseUpsPage;
